/** 资源管理相关Api */
import { App, defineAppApi } from '@zto/zpage'

import type { AppFsApi } from '@zto/zpage'

export default defineAppApi<AppFsApi>((app: App) => {
  return {
    baseUrl: app.env.apiUrl,

    config: { baseUrl: app.env.apiUrl },

    methods: (api: any) => {
      return {
        // 根据文件名获取外部文件访问地址
        async getFileUrls(fileIds: string[]) {
          return fileIds
        },

        // 获取OSS文件上传签名信息
        async getUploadToken(fileSuffix: string) {
          return api.fetch({
            url: '/cabinet/admin/base/AdminBaseCommonQueryController/getFileUploadSignature',
            data: {
              fileSuffix
            }
          })
        }
      }
    }
  }
})
